import React, {Component} from 'react';
import "../NavigationPage.css";
import TestMenuContent from "./../TestMenuContent";

class NavigationPage4 extends Component {

    render() {
        return (

            <div className="footer-navigation-content">
                <div className="footer-navigation-div">
                    <div className="spacer"></div>
                    {/* GERBER DATA作成について​*/}
                    <div id="footer-menu4-item1">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            推奨されるGERBERDATAのファイル名
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu4-item2">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            オンラインガーバービューア
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu4-item3">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            Altium PCBからガーバーファイルへ
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu4-item4">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            イーグルPCBからガーバーファイルへ
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu4-item5">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            Kicad PCBからガーバーファイルへ
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu4-item6">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            Diptrace PCBからガーバーファイルへント
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

}
export default NavigationPage4;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage4.js